var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-select',{attrs:{"options":_vm.optionsUniquePendencyOpned},model:{value:(_vm.modelComp),callback:function ($$v) {_vm.modelComp=$$v},expression:"modelComp"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }